import { render } from "./ActionMessage.vue?vue&type=template&id=0221d74a"
import script from "./ActionMessage.vue?vue&type=script&lang=js"
export * from "./ActionMessage.vue?vue&type=script&lang=js"
script.render = render

export default script